export interface SetupVpcPeeringWizardState {
  workspaceId: string;
  awsAccountId: string;
  vpcId: string;
  cidrs: string;
}

export const defaultSetupVpcPeeringWizardState: SetupVpcPeeringWizardState = {
  workspaceId: '',
  awsAccountId: '',
  vpcId: '',
  cidrs: '',
};
